export class CustomModule {
  constructor (App = null) {
    this.App = App;
  }

  bindAll (context) {
    $('#web-message [role=close]').on('click', function () {
      $('#web-message').remove();
    });
  }
}



// WEBPACK FOOTER //
// ./devel/js/custom.js